var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Confirm',{ref:"confirmDuplicate",attrs:{"confirm-color":"info","cancel-color":"disabled"}})
}
var staticRenderFns = []

export { render, staticRenderFns }